module.exports = __webpack_public_path__ + "static/media/virus.62074137.svg";